import React, { useEffect, useState } from "react";
import apiClient from "../BaseUrl/apiClient.js";
import SriyanshCardHeader from "../components/CardHeader";

import {
  Box,
  Card,
  CardContent,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  FormControl,
  Typography,
} from "@mui/material";
import TokenService from "../service/TokenService";
import ToasterAlerts from "../components/ToasterAlerts";
//import WhatsAppButton from '../whatsapp/WhatsAppButton';
import { BoxStyle } from "../constantVaribles/constatanvariable";
import { useNavigate } from "react-router-dom";
import WhatsAppButton from "../whatsapp/WhatsAppButton.js";


const EmailForm = () => {
  //const [email, setEmail] = useState("amitprasri@gmail.com");

  const [message, setMessage] = useState("");
  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
const email = tokenServiceDetails?.emailid;

//console.log(email);


  const [error, setError] = useState("");
  const [file, setFile] = useState(null);

  const [fileSizeError, setFileSizeError] = useState(null);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0]; // Get the selected file
    // Check if the file is selected
    if (selectedFile) {
      const maxSize = 1 * 1024 * 1024; // 5MB max file size in bytes
      if (selectedFile.size > maxSize) {
        setFileSizeError("File size exceeds 1MB.");
        setFile(null); // Reset file if size exceeds limit
      } else {
        setFileSizeError(null);
        setFile(selectedFile); // Set the file if within size limit
      }
    }
  };

  const [suggetion, setsuggetion] = useState("");
  const [suggetions, setsuggetions] = useState([]);

  const navigate = useNavigate();

  const handleClose = () => {
    navigate(-1);
  };

  const fetchSuggestions = async () => {
    try {
      const response = await apiClient.post("/SuggestionList", {
        /* request payload if needed */
      });
      setsuggetions(response.data); // Assuming response.data is an array of roles
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  useEffect(
    () => {
      // Update state if roles change (in case roles are updated dynamically)
      if (suggetions.length > 0) {
        setsuggetion(suggetions[0].suggestionType);
      }
    },
    [suggetions],
    error
  );

  useEffect(() => {
    fetchSuggestions();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (fileSizeError && fileSizeError.length > 0) {
      alert("File Size is more then required size");
    } else {
      try {
        // Create a new FormData object
        const formData = new FormData();
        formData.append("suggestion", suggetion); // Ensure 'suggestion' is correct
        formData.append("message", message);
        formData.append("uname", uname);
        formData.append("email", email);
        
        //console.log(file);
        // Append file if it exists
        if (file) {
          formData.append("file", file);
        }
//console.log(formData);
       // Send the form data using the POST method
        const response = await apiClient.post("/sendemail", formData, {
          // headers: {
          //   "Content-Type": "multipart/form-data",  // Ensure that the correct content type is set
          // },
        });

        // Handle successful email sending
        alert("Email sent successfully!");
        //setEmail("");   // Clear email field
        setMessage(""); // Clear message field
        setFile(null);
      } catch (error) {
        // Handle error in case of failure
        alert("Failed to send email.");
        console.error("Error sending email:", error); // Log error for debugging
      }
    }
  };

 return (
  <Box
    sx={{
      width: "100%",
      maxWidth: "100%",
      minWidth: 0,
      boxSizing: "border-box",
      overflowX: "hidden",
      p: { xs: 1, sm: 1.5, md: 2 },
    }}
  >
    <Card
      sx={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        overflow: "hidden",
        borderRadius: { xs: 2, md: 2.5 },
        border: "1px solid #dbe5f0",
        boxShadow: "0 4px 18px rgba(13, 71, 161, 0.10)",
        backgroundColor: "#fff",
      }}
    >
      {/* ================= HEADER ================= */}
      <Box
        sx={{
          background:
            "linear-gradient(135deg, #0D47A1 0%, #1565C0 50%, #1976D2 100%)",
          color: "#fff",
          px: { xs: 1.5, sm: 2, md: 2.5 },
          py: { xs: 1.4, sm: 1.6 },
          minHeight: { xs: 54, sm: 60 },
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: "0.95rem", sm: "1.1rem", md: "1.25rem" },
            fontWeight: 700,
            lineHeight: 1.4,
            overflowWrap: "anywhere",
          }}
        >
          Help Desk — Arvind 📱 9794840488 or Amit 📱 9450887365
        </Typography>
      </Box>

      {/* ================= ERROR MESSAGE ================= */}
      {error && (
        <ToasterAlerts
          type="info"
          title="Message"
          errorMessage={error}
          displaytime={2000}
          handleClose={() => {
            setError("");
          }}
        />
      )}

      <CardContent
        sx={{
          p: { xs: 1.25, sm: 2, md: 2.5 },
          "&:last-child": {
            pb: { xs: 1.5, sm: 2, md: 2.5 },
          },
        }}
      >
        <Box
          component="form"
          sx={{
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            boxSizing: "border-box",
          }}
        >
          {/* ================= FORM SECTION ================= */}
          <Box
            sx={{
              border: "1px solid #dbe5f0",
              borderRadius: 2,
              overflow: "hidden",
            }}
          >
            {/* SECTION HEADER */}
            <Box
              sx={{
                px: { xs: 1.25, sm: 1.75 },
                py: 1,
                background:
                  "linear-gradient(135deg, #e3f2fd 0%, #f5f9ff 100%)",
                borderBottom: "1px solid #dbe5f0",
              }}
            >
              <Typography
                sx={{
                  color: "#0D47A1",
                  fontWeight: 700,
                  fontSize: { xs: "0.9rem", sm: "1rem" },
                }}
              >
                Help Desk Message
              </Typography>
            </Box>

            <Box
              sx={{
                p: { xs: 1.25, sm: 2, md: 2.5 },
                width: "100%",
                maxWidth: "100%",
                minWidth: 0,
                boxSizing: "border-box",
              }}
            >
              <Grid
                container
                spacing={{ xs: 1.5, sm: 2 }}
                sx={{
                  width: "100%",
                  maxWidth: "100%",
                  minWidth: 0,
                  m: 0,
                }}
              >
                {/* ================= SUGGESTION TYPE ================= */}
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{
                    minWidth: 0,
                    pl: { xs: "0 !important", md: "16px !important" },
                  }}
                >
                  <FormControl fullWidth size="small">
                    <InputLabel id="helpdesk-label">
                      Help Desk Type
                    </InputLabel>

                    <Select
                      labelId="helpdesk-label"
                      value={suggetion}
                      id="helpdesk"
                      label="Help Desk Type"
                      onChange={(e) =>
                        setsuggetion(e.target.value)
                      }
                      sx={{
                        backgroundColor: "#fff",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#cbd8e6",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#1976D2",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#1565C0",
                        },
                      }}
                    >
                      {suggetions.map((Item) => (
                        <MenuItem
                          key={Item.suggestionType}
                          value={Item.suggestionType}
                          sx={{
                            whiteSpace: "normal",
                            overflowWrap: "anywhere",
                          }}
                        >
                          {Item.suggestionType}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* ================= MESSAGE ================= */}
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{
                    minWidth: 0,
                    pl: { xs: "0 !important", md: "16px !important" },
                  }}
                >
                  <TextField
                    label="Message"
                    value={message}
                    id="message"
                    onChange={(e) => {
                      const value = e?.target?.value || "";

                      if (`${value}`.length <= 250) {
                        setMessage(value);
                      }
                    }}
                    required
                    fullWidth
                    multiline
                    rows={4}
                    helperText={`${message.length}/250 characters`}
                    sx={{
                      minWidth: 0,
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "#fff",
                      },
                      "& .MuiOutlinedInput-root:hover fieldset": {
                        borderColor: "#1976D2",
                      },
                      "& .MuiOutlinedInput-root.Mui-focused fieldset": {
                        borderColor: "#1565C0",
                      },
                    }}
                  />
                </Grid>

                {/* ================= FILE ATTACHMENT ================= */}
                {/* <Grid
                  item
                  xs={12}
                  sx={{
                    minWidth: 0,
                    pl: { xs: "0 !important", md: "16px !important" },
                  }}
                >
                  <Box
                    sx={{
                      border: "1px dashed #90caf9",
                      borderRadius: 2,
                      p: { xs: 1.25, sm: 1.5 },
                      backgroundColor: "#f7fbff",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: { xs: "0.8rem", sm: "0.85rem" },
                        fontWeight: 600,
                        color: "#0D47A1",
                        mb: 0.75,
                      }}
                    >
                      Attachment
                    </Typography>

                    <input
                      type="file"
                      onChange={handleFileChange}
                      style={{
                        width: "100%",
                        maxWidth: "100%",
                        boxSizing: "border-box",
                        fontSize: "0.85rem",
                      }}
                    />

                    <Typography
                      sx={{
                        mt: 0.6,
                        fontSize: "0.72rem",
                        color: "#607d8b",
                      }}
                    >
                      Maximum file size: 1 MB
                    </Typography>

                    {file && (
                      <Typography
                        sx={{
                          mt: 0.5,
                          fontSize: "0.78rem",
                          color: "#1565C0",
                          fontWeight: 600,
                          overflowWrap: "anywhere",
                        }}
                      >
                        Selected: {file.name}
                      </Typography>
                    )}

                    {fileSizeError && (
                      <Typography
                        sx={{
                          mt: 0.5,
                          fontSize: "0.78rem",
                          color: "#d32f2f",
                          fontWeight: 600,
                        }}
                      >
                        {fileSizeError}
                      </Typography>
                    )}
                  </Box>
                </Grid> */}
              </Grid>
            </Box>
          </Box>

          {/* ================= USER INFORMATION ================= */}
          <Box
            sx={{
              mt: { xs: 1.5, sm: 2 },
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(2, minmax(0, 1fr))",
              },
              gap: 1.25,
            }}
          >
            <Box
              sx={{
                p: 1.25,
                borderRadius: 1.5,
                backgroundColor: "#eef6ff",
                border: "1px solid #cfe2ff",
                minWidth: 0,
              }}
            >
              <Typography
                sx={{
                  fontSize: "0.72rem",
                  color: "#607d8b",
                }}
              >
                User
              </Typography>

              <Typography
                sx={{
                  fontSize: "0.85rem",
                  fontWeight: 700,
                  color: "#0D47A1",
                  overflowWrap: "anywhere",
                }}
              >
                {uname || "-"}
              </Typography>
            </Box>

            <Box
              sx={{
                p: 1.25,
                borderRadius: 1.5,
                backgroundColor: "#eef6ff",
                border: "1px solid #cfe2ff",
                minWidth: 0,
              }}
            >
              <Typography
                sx={{
                  fontSize: "0.72rem",
                  color: "#607d8b",
                }}
              >
                Email
              </Typography>

              <Typography
                sx={{
                  fontSize: "0.85rem",
                  fontWeight: 700,
                  color: "#0D47A1",
                  overflowWrap: "anywhere",
                  wordBreak: "break-word",
                }}
              >
                {email || "-"}
              </Typography>
            </Box>
          </Box>

          {/* ================= ACTION BUTTONS ================= */}
          <Box
            sx={{
              mt: { xs: 1.5, sm: 2 },
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(2, minmax(0, 1fr))",
              },
              gap: 1.25,
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
            }}
          >
            <button
              className="button button1"
              type="button"
              onClick={handleSubmit}
              title="Click for send Mail"
              style={{
                width: "100%",
                minHeight: "42px",
                border: "none",
                borderRadius: "8px",
                background:
                  "linear-gradient(135deg, #0D47A1 0%, #1565C0 100%)",
                color: "#fff",
                fontWeight: 700,
                cursor: "pointer",
                boxShadow: "0 3px 8px rgba(13, 71, 161, 0.22)",
              }}
            >
              Send Mail
            </button>

            <button
              className="button button1"
              type="button"
              onClick={handleClose}
              title="Close"
              style={{
                width: "100%",
                minHeight: "42px",
                border: "none",
                borderRadius: "8px",
                background:
                  "linear-gradient(135deg, #c62828 0%, #e53935 100%)",
                color: "#fff",
                fontWeight: 700,
                cursor: "pointer",
                boxShadow: "0 3px 8px rgba(198, 40, 40, 0.20)",
              }}
            >
              Close
            </button>
          </Box>
        </Box>
      </CardContent>
    </Card>

    {/* ================= WHATSAPP ================= */}
    <WhatsAppButton />
  </Box>
);
};

export default EmailForm;
